/* eslint-disable relay/unused-fields */
import { useMemo } from 'react';
import { fetchQuery, graphql } from 'react-relay';
import {
	type OptionResponse,
	createDebouncedColumnLoader,
} from '@atlassian/jira-native-issue-table';
import JiraRelayEnvironment from '@atlassian/jira-relay-environment';
import { useCloudId } from '@atlassian/jira-tenant-context-controller';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapColumnPickerOptions = (data: any): OptionResponse => {
	const options = data.jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.map(
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(edge: { cursor: any; node: { fieldSetId: any; displayName: any } }) => ({
			optionType: 'option',
			cursor: edge.cursor,
			value: edge.node.fieldSetId,
			label: edge.node.displayName,
		}),
	);
	return {
		options,
		totalCount: data.jira.issueSearchViewByNamespaceAndViewId.fieldSets.totalCount,
		endCursor: data.jira.issueSearchViewByNamespaceAndViewId.fieldSets.pageInfo.endCursor,
	};
};

export const useColumnLoader = () => {
	const cloudId = useCloudId();
	const environment = JiraRelayEnvironment;
	return useMemo(
		() =>
			createDebouncedColumnLoader(async (search, renderInitialValues, endCursor) => {
				const cursor = endCursor;
				try {
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					const data = await fetchQuery<any>(
						environment,
						graphql`
							query columnConfigurabilityfetchColumnPickerConfigureableChildIssuesPanelQuery(
								$cloudId: ID!
								$namespace: String
								$first: Int
								$after: String
								$filter: JiraIssueSearchFieldSetsFilter
							) {
								jira {
									issueSearchViewByNamespaceAndViewId(cloudId: $cloudId, namespace: $namespace) {
										fieldSets(first: $first, filter: $filter, after: $after) {
											totalCount
											pageInfo {
												endCursor
											}
											edges {
												cursor
												node {
													fieldSetId
													displayName
													type
													fieldType {
														displayName
													}
												}
											}
										}
									}
								}
							}
						`,
						{
							cloudId,
							namespace: 'ISSUE_NAVIGATOR',
							first: 25,
							after: cursor,
							filter: {
								searchString: search,
								fieldSetSelectedState: 'ALL',
							},
						},
					).toPromise();
					return mapColumnPickerOptions(data);
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
				} catch (error: any) {
					return {
						options: [
							{
								optionType: 'error',
								error,
								onRetry: () => undefined,
							},
						],
						totalCount: 0,
					};
				}
			}),
		[environment, cloudId],
	);
};
